import { Link } from "react-scroll";
import React from 'react';

function Navbar() {
  document.addEventListener("scroll", function (e) {
    if (window.screen.width < 768 && window.scrollY > 100) {
      const gotop = document.querySelector(".gotop");
      gotop.classList.add("display");

      const nav = document.querySelector(".navbary");

      nav.classList.add("navopened");
    } else if (window.screen.width > 768 && window.scrollY > 100) {
      const gotop = document.querySelector(".gotop");
      gotop.classList.add("display");

      const nav = document.querySelector(".navbary");

      nav.classList.add("navopened");
    } else {
      const nav = document.querySelector(".navbary");
      const gotop = document.querySelector(".gotop");
      gotop.classList.remove("display");
      nav.classList.remove("navopened");
    }
  });
  function openBar() {
    const bar = document.querySelector(".bar");

    bar.classList.toggle("opened");
  }

  return (
    <nav className="navbary">
      <div className="containery">
        <div className="rowy">
          <h1 className="logo">
            <Link spy smooth duration={800} to="hero" href="#hero" style={{ cursor: 'pointer' }}>
              RENSTIA UG LTD
            </Link>
          </h1>
          <ul className="bar">
            <li>
              <a
                activeClass="active"
                href="#home"
                onClick={openBar}
              >
                Home
              </a>
            </li>
            <li>
              <a activeClass="active" href="#services" onClick={openBar}>
                Services
              </a>
            </li>
            <li>
              <a activeClass="active" href="#products" onClick={openBar}>
                Products
              </a>
            </li>
            <li>
              <a activeClass="active" href="#compliance" onClick={openBar}>
                Compliance
              </a>
            </li>
            <li>
              <a activeClass="active" href="#about" onClick={openBar}>
                About
              </a>
            </li>
            <li>
              <a
                href="#contact"
                activeClass="active"
                onClick={openBar}
              >
                Contact
              </a>
            </li>
          </ul>
          <div className="button" onClick={openBar}>
            <div className="burger"></div>
            <div className="burger"></div>
            <div className="burger"></div>
          </div>
        </div>
      </div>
    </nav>
  );
}
export default Navbar;
